
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPending as ObiPendingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pending.js';
 
 
 

 
 export const ObiPending = createComponent({
   react: React,
   tagName: 'obi-pending',
   elementClass: ObiPendingElement,
   events: {
     
   }
  });
 
 